export default {
  "base": "border-t border-default my-12"
}